"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.modals = void 0;
const basic_1 = require("../basic");
const font_faces_1 = require("./font-faces");
const colors_1 = require("../basic/colors");
const small_modal_wrapper_1 = require("../basic/small-modal-wrapper");
exports.modals = (0, basic_1.applyBase)({
    '.modal-title': font_faces_1.FONT_SIZE.S,
    modalContentStyles: {
        flex: '1',
        flexDirection: 'column',
        p: 4,
        pb: 5,
        '> *': {
            flexShrink: '0',
        },
    },
    catalogErrorModal: {
        '.modal-body': {
            p: [4, 5],
        },
        '.modal-wrapper': small_modal_wrapper_1.smallModalWrapper,
        '.modal-shadow': {
            backgroundColor: colors_1.colors.modalShadow,
        },
    },
    forgotPasswordModal: {
        '.modal-wrapper': {
            width: '100%',
            maxWidth: '450px',
            position: 'relative',
            height: [null, 'auto'],
            borderRadius: ['roundedTop', '0px'],
            '.modal-body, .modal-header': {
                backgroundColor: 'authModalBackgroundColor',
            },
            '.modal-header': {
                fontSize: [3, 4],
                px: 4,
            },
        },
    },
    wideModalWrapper: {
        maxWidth: [null, '970px'],
        borderRadius: ['roundedTop', '0px'],
        height: [null, 'auto'],
        '.modal-title': font_faces_1.FONT_SIZE.S,
    },
    mediumModalWrapper: {
        maxWidth: [null, '572px'],
        borderRadius: 4,
        height: [null, 'auto'],
        '.modal-title': font_faces_1.FONT_SIZE.S,
    },
    wideModalHeader: {
        py: [2, '14px'],
        px: ['20px', '36px'],
    },
    actionlessModalWrapper: {
        maxWidth: [null, '970px'],
        borderRadius: 'default',
        mx: [4, 0],
        alignSelf: 'center',
    },
    smallModalWrapper: {
        width: ['100%', 'auto'],
        '.modal-title': Object.assign(Object.assign({}, font_faces_1.FONT_SIZE.S), { mr: 3 }),
    },
    commonModalBody: {
        px: [4, '40px'],
        pt: [4, '30px'],
        pb: [4, '40px'],
    },
    confirmationControls: {
        width: '100%',
        flexDirection: ['column', 'row'],
        justifyContent: [null, 'flex-end'],
        px: [4, 0],
        button: {
            minWidth: '150px',
        },
        pb: 4,
    },
    notificationCardWrapWithError: {
        textAlign: 'center',
        backgroundColor: 'background',
        borderColor: 'borderGreyFifth',
        p: [null, 3],
        pt: 4,
        borderRadius: 'default',
        paddingTop: 0,
        boxShadow: 'none',
        '.notification-content': { maxWidth: '250px', margin: 'auto' },
        '.heading': {
            fontSize: 3,
            mb: 2,
        },
        '.text': {
            mb: 4,
        },
    },
    absoluteDropdownBox: {
        bg: 'background',
        top: '0',
        width: ['auto', '100%'],
        position: 'absolute',
        zIndex: '10',
        boxShadow: 'cardShadow',
    },
});
//# sourceMappingURL=modals.js.map